import React from 'react'
import './Whatsapp.css'
import icon from './w-img/wtp.gif'

const Whatsapp = () => {
  return (
    <div className='whatsapp-main'>
      <a href="https://wa.me/+918012523333">
        <i class="fa-brands fa-whatsapp"></i>
      </a>
    </div>
  )
}

export default Whatsapp